import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

export const SET_PACIENTI = 'SET_PACIENTI'

Vue.use(VueMoment, {
  moment
})

export default {
  [SET_PACIENTI] (state, payload) {
    state.pacienti = []
    Object.values(payload).forEach(function (pacientiNode) {
      state.pacienti.push({
        uid: pacientiNode.uid[0].value,
        uuid: pacientiNode.uuid[0].value,
        mail: !(pacientiNode.mail == '')
          ? pacientiNode.mail[0].value
          : '',
        device: !(pacientiNode.field_token == '')
          ? pacientiNode.field_token[0].value
          : '',
        uservalue: [{uid: pacientiNode.uid[0].value}, {uuid: pacientiNode.uuid[0].value}],
        nume: !(pacientiNode.field_nume == '')
          ? pacientiNode.field_nume[0].value
          : '',
        prenume: !(pacientiNode.field_prenume == '')
          ? pacientiNode.field_prenume[0].value
          : '',
        fullnume: !(pacientiNode.field_nume == '')
          ? pacientiNode.field_nume[0].value + ' ' + pacientiNode.field_prenume[0].value
          : '',
        uidMedic: !(pacientiNode.field_my_medic == '')
          ? pacientiNode.field_my_medic
          : '',
        uuidMedic: !(pacientiNode.field_my_medic == '')
          ? pacientiNode.field_my_medic
          : '',
        filesP: !(pacientiNode.field_files_1 == '')
          ? pacientiNode.field_files_1
          : '',
        sex: (pacientiNode.field_sex == '')
          ? 'N'
          : (pacientiNode.field_sex[0].value === 'barbatesc')
            ? 'B'
            : (pacientiNode.field_sex[0].value === 'femeiesc')
              ? 'F'
              : 'N',
        sursa: !(pacientiNode.field_sursa == '')
          ? pacientiNode.field_sursa[0].value
          : 'null',
        datanasterii: !(pacientiNode.field_data_nasterii == '')
          ? moment(pacientiNode.field_data_nasterii[0].value).format('DD MMMM YYYY')
          : '-',
        telefon: !(pacientiNode.field_telefon == '')
          ? pacientiNode.field_telefon[0].value
          : '',
        picture: !(pacientiNode.user_picture == '')
          ? pacientiNode.user_picture[0].url
          : 'http://dental.pixelit.ro/images/no-user.png'
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pacienti/PacientiMutations.js